/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the ProblemReportRequest interface.
 */
export function instanceOfProblemReportRequest(value) {
    let isInstance = true;
    return isInstance;
}
export function ProblemReportRequestFromJSON(json) {
    return ProblemReportRequestFromJSONTyped(json, false);
}
export function ProblemReportRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'message': !exists(json, 'message') ? undefined : json['message'],
        'contactEmail': !exists(json, 'contactEmail') ? undefined : json['contactEmail'],
        'pagePath': !exists(json, 'pagePath') ? undefined : json['pagePath'],
    };
}
export function ProblemReportRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'message': value.message,
        'contactEmail': value.contactEmail,
        'pagePath': value.pagePath,
    };
}
